import { css } from "styled-components";
import { IMenuElementStyleProps } from "./interfaces";

export const MenuElement = css<IMenuElementStyleProps>`
    position: relative;
    display: flex;
    align-items: center;
    margin: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: color 0.2s;
    vertical-align: top;
    color: ${p => p.theme.c.dark};

    svg {
        transition: fill 0.2s;
        fill: ${p => p.theme.c.dark};
    }

    :hover {
        color: ${p => p.theme.c.pale};

        svg {
            fill: ${p => p.theme.c.pale};
        }
    }

    ${p =>
        p.theme.xs(css`
            display: none;
        `)}

    ${p =>
        p.$isActive
            ? css`
                  color: ${p => p.theme.c.snow};

                  svg {
                      fill: ${p => p.theme.c.snow} !important;
                  }

                  &:hover {
                      color: ${p => p.theme.c.snow};

                      svg {
                          fill: ${p => p.theme.c.snow};
                      }
                  }
              `
            : undefined}
`;
